var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"heit-beats"}},[_c('Header'),_vm._l((_vm.beats),function(beat){return _c('div',[_vm._v("\n\t\t   "+_vm._s(beat.title)+" "),_c('button',{on:{"click":function($event){return _vm.addSong(beat)}}},[_vm._v("+")])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }